module.exports = __webpack_public_path__ + "static/media/webinarFunnel.66990077.png";